module.exports = __webpack_public_path__ + "img/mkgest-icon.b1dac5d0.png";